export type BandRangeKind = 'students' | 'usd';

function formatRangeBound(n: number, kind: BandRangeKind): string {
  if (kind === 'usd') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    }).format(n);
  }
  return n.toLocaleString(undefined, { maximumFractionDigits: 0 });
}

/** e.g. 161–317 students or $425–$1,695 */
export function formatBandRange(min: number, max: number, kind: BandRangeKind): string {
  const lo = formatRangeBound(min, kind);
  const hi = formatRangeBound(max, kind);
  const suffix = kind === 'students' ? ' students' : '';
  return `${lo}–${hi}${suffix}`;
}

export interface BandLabelSource {
  name?: string | null;
  fullName?: string | null;
  minValue: number;
  maxValue: number;
}

/** Prefer API `fullName`; otherwise `{name} ({range})`. */
export function bandFullName(item: BandLabelSource, kind: BandRangeKind): string {
  const fromApi = item.fullName?.trim();
  if (fromApi) return fromApi;
  const name = (item.name ?? '').trim() || 'Band';
  const min = Number(item.minValue);
  const max = Number(item.maxValue);
  if (Number.isFinite(min) && Number.isFinite(max)) {
    return `${name} (${formatBandRange(min, max, kind)})`;
  }
  return name;
}

export function buildComposedPeerGroupLabel(params: {
  governorateName?: string;
  schoolBandDisplay?: string;
  tuitionBandDisplay?: string;
  parentBandDisplay?: string;
}): string {
  const parts: string[] = [];
  if (params.governorateName?.trim()) {
    parts.push(`Governorate: ${params.governorateName.trim()}`);
  }
  if (params.schoolBandDisplay?.trim()) {
    parts.push(`School size: ${params.schoolBandDisplay.trim()}`);
  }
  if (params.tuitionBandDisplay?.trim()) {
    parts.push(`Tuition: ${params.tuitionBandDisplay.trim()}`);
  }
  if (params.parentBandDisplay?.trim()) {
    parts.push(`Parent fee: ${params.parentBandDisplay.trim()}`);
  }
  return parts.length > 0 ? parts.join(' · ') : 'All schools';
}
